import React, { /*useCallback,*/ useState, useEffect, Fragment, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
//import settings from './../../Settings.json';
import { ToastContainer, toast } from "react-toastify";
import { useDownloadExcel } from 'react-export-table-to-excel';
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask';
import { decodeToken, isExpired } from "react-jwt";

const Kullanici = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [prm, setPrm] = useState("");
    const [currentId, setCurrentId] = useState(0);
    const [ad, setAd] = useState('');
    const [soyad, setSoyad] = useState('');
    const [telefonCep, setTelefonCep] = useState('');
    const [telefonIs, setTelefonIs] = useState('');
    const [eMail, setEMail] = useState('');
    const [bildirimGonder, setBildirimGonder] = useState(false);
    const [aktif, setAktif] = useState(true);

    const [data, setData] = useState([]);
    const [rolList, setRolList] = useState([]);
    const [checkAll, setCheckAll] = useState(false);

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            setShow(false);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const rolListOnUpdate = (index, checked) => {
        const rolListTemp = [...rolList];
        rolListTemp[index].checked = checked;
        setRolList(rolListTemp);
    };

    const tableRef = useRef(null);

    const maskGenerator = createDefaultMaskGenerator('999 999 99 99');

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [prm]);

    const handleBildirimGonderChange = (e) => {
        setBildirimGonder(e.target.checked);
    }

    const handleAktifChange = (e) => {
        setAktif(e.target.checked);
    }

    const handlePrmChange = (e) => {
        if (tokenYenile() === false) {
            return;
        }

        setPrm(e.target.value);
    }

    const handleCheckAll = () => {
        setCheckAll(!checkAll);

        const temp = rolList;

        temp.forEach(item => {
            item.checked = !checkAll;
        });

        setRolList(temp);
    }

    const getAcilisData = async() => {
        if (await tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Ayarlar - Kullanıcılar - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("Ayarlar - Kullanıcılar - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("Ayarlar - Kullanıcılar - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("Ayarlar - Kullanıcılar - Sil"));
    
            setRolList((await axios.get(settings.ApiUrl + 'Rol/GetRolList', { headers: AuthService.getHeaders() })).data.value);

            await getData();
        }
    }

    const getData = async () => {
        try {
            const res = await axios.get(settings.ApiUrl + 'Kullanici/GetKullaniciList/' + (prm === "" ? "~" : prm), { headers: AuthService.getHeaders() });

            if (res) {
                setData(res.data.value);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const Ekle = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        setCurrentId(0);
        setAd("");
        setSoyad("");
        setTelefonCep("");
        setTelefonIs("");
        setEMail("");
        setBildirimGonder(false);
        setAktif(true);

        let temp = rolList;

        temp.forEach(rol => {
            rol.checked = false;
        });                    

        setRolList(temp);

        handleShow();
    }

    const Degistir = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        try {
            const result = await axios.get(settings.ApiUrl + 'Kullanici/GetKullanici/' + id, { headers: AuthService.getHeaders() });

            if (result) {
                setCurrentId(id);
                setAd(result.data.value.ad);
                setSoyad(result.data.value.soyad);
                setTelefonCep(result.data.value.telefonCep);
                setTelefonIs(result.data.value.telefonIs);
                setEMail(result.data.value.eMail);
                setBildirimGonder(result.data.value.bildirimGonder);
                setAktif(result.data.value.aktif);

                if (rolList && rolList.length > 0 && result.data.value.roller) {
                    let temp = rolList;

                    temp.forEach(rol => {
                        const exist = result.data.value.roller.filter(item => item.id === rol.id);
                        rol.checked = exist && exist.length > 0;
                    });

                    setRolList(temp);
                }

                handleShow();
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Sil = async (id) => {
        if (await tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'Kullanici/GetKullanici/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Kullanici/DeleteKullanici/', [resultGet.data.value], { headers: AuthService.getHeaders() });
                        
                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                getData();
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        if (ad === "" || soyad === "" || eMail === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "id": currentId,
                    "ad": ad,
                    "soyad": soyad,
                    "telefonCep": telefonCep,
                    "telefonIs": telefonIs,
                    "email": eMail,
                    "bildirimGonder": bildirimGonder,
                    "aktif": aktif,
                    "roller": rolList.filter(item => item.checked === true)
                });
    
                const result = await axios.post(settings.ApiUrl + 'Kullanici/InsertOrUpdateKullanici/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success) {
                        handleClose();
                        getData();
                        toast.success("Kaydedildi");

                        /*if (currentId === 0) {
                            SifreLinkiGonderBase(eMail, currentId === 0 ? true : false);
                        }*/                       
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            }
        }
    }

    const SifreLinkiGonderBase = async (mail, yeniKullanici) => {
        try {
            const resultKey = await axios.get(settings.ApiUrl + 'Login/GetAktivasyonKoduByMail/' + mail, { headers: AuthService.getHeaders() });

            if (resultKey.data.success) {
                const url = "<a href='" + window.location.origin + "/Auth/ActivatePassword?C=" + resultKey.data.value + "'>Şifrenizi belirlemek için tıklayınız</a>";

                const postData = JSON.stringify({
                    "yeniKullanici": yeniKullanici,
                    "url": url,
                    "mail": mail
                });

                const resultMail = await axios.post(settings.ApiUrl + 'Mail/SendPasswordLink/', postData, { headers: AuthService.getHeaders() });

                if (resultMail.data.success) {
                    toast.success("Kullanıcıya şifre belirleme adresi e-posta ile gönderildi");
                } else {
                    toast.error(resultMail.data.message);
                }
            } else {
                toast.error(resultKey.data.message);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const SifreLinkiGonder = async (mail) => {
        if (await tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kullanıcıya şifre belirleme adresi e-posta ile gönderilecek, devam edilsin mi?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Gönder",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                SifreLinkiGonderBase(mail, false);
            }
        });
    }

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'KullaniciListesi',
        sheet: 'KullaniciListesi'
    })

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>
            <div className="row">
                <div className="col-md-10">
                    <PageTitle></PageTitle>
                </div>
                <div className="col-md-2 text-right">
                    <div className="input-group input-group-sm mb-3">
                        <input type="text" className="form-control" aria-describedby="inputGroup-sizing-sm" placeholder="Arama..." value={prm} onChange={(e) => handlePrmChange(e)}></input>
                        <span className="input-group-text" id="inputGroup-sizing-sm"><i className="bi bi-search"></i></span>
                    </div>
                </div>
            </div>

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <div className="card info-card mb-2">
                                <div className="table-responsive">
                                    <table ref={tableRef} className="table table-bordered table-hover table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th>Ad</th>
                                                <th>Soyad</th>
                                                <th>E-Posta</th>
                                                <th>Cep Telefonu</th>
                                                <th>İş Telefonu</th>
                                                <th>Roller</th>
                                                <th style={{textAlign:"center"}}>Bildirim Gönder</th>
                                                <th style={{textAlign:"center"}}>Durumu</th>
                                                <th style={{textAlign:"center"}}>
                                                    { yetkiEkle ? <button className="btn btn-sm btn-icon text-success" onClick={() => Ekle()}><i className="bi bi-plus-circle"></i></button> : '' }
                                                    <button className="btn btn-sm btn-icon text-success" onClick={onDownload}><i className="bi bi-file-earmark-excel"></i></button>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data && data.length > 0 ?
                                                    data.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{item.ad}</td>
                                                                <td>{item.soyad}</td>
                                                                <td>{item.eMail}</td>
                                                                <td>{item.telefonCep}</td>
                                                                <td>{item.telefonIs}</td>
                                                                <td>{item.rollerString}</td>
                                                                <td align="center">{item.bildirimGonder === true ? <span className="badge bg-primary">Evet</span> : <span className="badge bg-warning">Hayır</span>}</td>
                                                                <td align="center">{item.aktif === true ? <span className="badge bg-success">Aktif</span> : <span className="badge bg-danger">Pasif</span>}</td>
                                                                <td align="center">
                                                                    { yetkiDegistir ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : '' }
                                                                    { yetkiSil ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : '' }
                                                                    { yetkiDegistir ? <button className="btn btn-sm btn-icon text-warning" onClick={() => SifreLinkiGonder(item.eMail)}><i className="bi bi-key"></i></button> : <label style={{width:"26px"}}></label> }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td align="center" colSpan="11" style={{height:"48px"}}>
                                                            Kayıt yok
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        :
                        ""
            }

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Kullanıcı Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblAd" style={{width:"128px"}}>Adı<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <input aria-describedby="lblAd" type="text" className="form-control form-control-sm" value={ad} onChange={(e) => setAd(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblSoyad" style={{width:"128px"}}>Soyadı<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <input aria-describedby="lblSoyad" type="text" className="form-control form-control-sm" value={soyad} onChange={(e) => setSoyad(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblEMail" style={{width:"128px"}}>E-Posta<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                <input aria-describedby="lblEMail" type="text" className="form-control form-control-sm" value={eMail} onChange={(e) => setEMail(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblTelefonCep" style={{width:"128px"}}>Cep Telefonu</label>
                                <MaskedInput aria-describedby="lblTelefonCep" maskGenerator={maskGenerator} className="form-control form-control-sm" value={telefonCep} onChange={setTelefonCep}></MaskedInput>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblTelefonIs" style={{width:"128px"}}>İş Telefonu</label>
                                <input aria-describedby="lblTelefonIs" type="text" className="form-control form-control-sm" value={telefonIs} onChange={(e) => setTelefonIs(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label htmlFor="cbbildirimGonder" className="input-group-text" id="lblbildirimGonder" style={{width:"128px"}}>Bildirim Gönder</label>
                                <div aria-describedby="lblbildirimGonder" className="form-control form-control-sm text-center">
                                    <input id="cbbildirimGonder" type="checkbox" className="form-check-input" checked={bildirimGonder} value={bildirimGonder} onChange={(e) => handleBildirimGonderChange(e)}></input>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="input-group input-group-sm">
                                <label htmlFor="cbAktif" className="input-group-text" id="lblAktif" style={{width:"128px"}}>Kullanıcı Aktif</label>
                                <div aria-describedby="lblAktif" className="form-control form-control-sm text-center">
                                    <input id="cbAktif" type="checkbox" className="form-check-input" checked={aktif} onChange={(e) => handleAktifChange(e)}></input>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="formControlBox">
                                <div className="input-group input-group-sm" style={{padding:"3px"}}>
                                    <input id="cbCheckAll" type="checkbox" checked={checkAll} onChange={handleCheckAll} className="form-check-input" style={{fontSize:"small"}}></input>
                                    <label htmlFor="cbCheckAll" className="labelForCheckBoxOrRadio" style={{fontWeight: "bold"}}>Tüm Roller</label>
                                </div>
                                <div style={{overflowY: "auto", height: "200px"}}>
                                    <table className="table table-hover table-sm table-borderless" style={{width:"auto"}}>
                                        <tbody>
                                            {
                                                rolList && rolList.length > 0 ?
                                                rolList.map((item, index) => {
                                                    return (
                                                        <tr key={item.id}>
                                                            <td>
                                                                <input id={"cbRol" + item.id} type="checkbox" className="form-check-input" checked={item.checked} onChange={() => rolListOnUpdate(index, !item.checked)}></input>
                                                            </td>
                                                            <td>
                                                                <label htmlFor={"cbRol" + item.id} style={{cursor:"pointer"}}>{item.rol}</label>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={2}>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleClose}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default Kullanici;